// import SelfService from './SelfService';

export default {
  // component: null,
  priority: 10,
  permissions: ['Reserve'],
  name: app.translate('routes.home.feed.Reserve'),
  icon: 'silverware',
  drawer: false,
};


